/**
 * Which years take travel choices IN ORDER?
 *
 * Every tenth year, once the game is past year 19, is a "special rift turn":
 * `players_choosing_planet` is sorted poorest-equity-first and only the player
 * at the head of that queue may pick — everyone else waits their turn. On every
 * other year the whole queue picks at once.
 *
 * Three places need that answer and must never disagree: the engine (which
 * refuses an out-of-order pick), the Waiting-for-Players list, and the Ready
 * gate (which offers travel choices only when the player can actually use
 * them). Offering a choice the engine would reject is worse than offering none,
 * so the rule lives here rather than being re-derived per view.
 */
export function isSpecialRiftTurn(turn: number): boolean {
  return turn % 10 === 0 && turn > 19
}
